interface StatusDotProps {
  active: boolean;
  title?: string;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
}

export function StatusDot({
  active,
  title,
  activeColor = '#047857',
  inactiveColor = '#9ca3af',
  className,
}: StatusDotProps) {
  return (
    <div
      className={`w-2.5 h-2.5 rounded-full ${className ?? ''}`}
      style={{ backgroundColor: active ? activeColor : inactiveColor }}
      title={title}
    />
  );
}
